import { useFormat } from './useFormat';

export const usePercentFormat = ({
  maximumFractionDigits = 2,
  minimumFractionDigits = 0,
  empty = '-',
  signDisplay = 'auto',
  notation = 'standard',
  compactDisplay = 'long',
} = {}) => {
  const formatter = useFormat({
    type: 'percent',
    maximumFractionDigits,
    minimumFractionDigits,
    empty,
    signDisplay,
    notation,
    compactDisplay,
  });
  return (value: number | undefined) => {
    return formatter(value !== undefined ? value / 100 : value);
  };
};
